import React from 'react';
import { Drawer, Button, Tag } from 'antd';
import { GiftOutlined, UserOutlined, CalendarOutlined, EditOutlined, DeleteOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styles from '../common/DrawerModalMobile.module.css';

interface GiftDetailModalMobileProps {
  isOpen: boolean;
  onClose: () => void;
  gift: any; // Gift type
  event?: any; // Event type
  giver?: any; // Giver type
  onEdit: (gift: any) => void;
  onDelete: (gift: any) => void;
}

export const GiftDetailModalMobile: React.FC<GiftDetailModalMobileProps> = ({
  isOpen,
  onClose,
  gift,
  event,
  giver,
  onEdit,
  onDelete,
}) => {
  if (!gift) return null;

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      height="90%"
      className={styles.drawer}
      bodyStyle={{ padding: 0 }}
    >
      <div className={styles.drawerContent}>
        <div className={styles.drawerBody}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 32, background: '#722ed1', color: '#fff', borderRadius: 12, width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <GiftOutlined />
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 18 }}>{gift.gift_name || 'Tiền mừng'}</div>
              <div style={{ color: '#888', fontSize: 14 }}>{event ? event.name : ''}</div>
            </div>
          </div>
          <div className={styles.drawerTable}>
            <div className={styles.drawerTableRow}>
              <div className={styles.drawerTableLabel}>Số tiền</div>
              <div className={styles.drawerTableValue}>{formatCurrency(gift.amount)}</div>
            </div>
            {gift.gift_type && (
              <div className={styles.drawerTableRow}>
                <div className={styles.drawerTableLabel}>Loại</div>
                <div className={styles.drawerTableValue}>{gift.gift_type === 'cash' ? 'Tiền mặt' : gift.gift_type === 'gift' ? 'Quà tặng' : 'Khác'}</div>
              </div>
            )}
            {gift.gift_value && (
              <div className={styles.drawerTableRow}>
                <div className={styles.drawerTableLabel}>Giá trị quà</div>
                <div className={styles.drawerTableValue}>{formatCurrency(gift.gift_value)}</div>
              </div>
            )}
            <div className={styles.drawerTableRow}>
              <div className={styles.drawerTableLabel}>Người mừng</div>
              <div className={styles.drawerTableValue}><UserOutlined /> {giver ? giver.full_name : ''}</div>
            </div>
            <div className={styles.drawerTableRow}>
              <div className={styles.drawerTableLabel}>Ngày mừng</div>
              <div className={styles.drawerTableValue}><CalendarOutlined /> {event ? event.event_date : ''}</div>
            </div>
            {gift.notes && (
              <div className={styles.drawerTableRow}>
                <div className={styles.drawerTableLabel}>Ghi chú</div>
                <div className={styles.drawerTableValue}>{gift.notes}</div>
              </div>
            )}
            <div className={styles.drawerTableRow}>
              <div className={styles.drawerTableLabel}>Trạng thái</div>
              <div className={styles.drawerTableValue}>
                <Tag color={gift.is_returned ? 'green' : 'orange'} icon={gift.is_returned ? <CheckCircleOutlined /> : null}>
                  {gift.is_returned ? 'Đã đáp lễ' : 'Chưa đáp lễ'}
                </Tag>
              </div>
            </div>
            {gift.is_returned && (
              <>
                {gift.return_date && (
                  <div className={styles.drawerTableRow}>
                    <div className={styles.drawerTableLabel}>Ngày đáp lễ</div>
                    <div className={styles.drawerTableValue}>{gift.return_date}</div>
                  </div>
                )}
                {gift.return_amount !== null && gift.return_amount !== undefined && (
                  <div className={styles.drawerTableRow}>
                    <div className={styles.drawerTableLabel}>Số tiền đáp lễ</div>
                    <div className={styles.drawerTableValue}>{formatCurrency(gift.return_amount)}</div>
                  </div>
                )}
                {gift.return_notes && (
                  <div className={styles.drawerTableRow}>
                    <div className={styles.drawerTableLabel}>Ghi chú đáp lễ</div>
                    <div className={styles.drawerTableValue}>{gift.return_notes}</div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className={styles.drawerFooter}>
          <div className={styles.drawerFooterRow}>
            <Button
              className={`${styles.drawerFooterButton} ${styles.primary}`}
              icon={<EditOutlined />}
              onClick={() => onEdit(gift)}
            >
              Sửa
            </Button>
            <Button
              className={`${styles.drawerFooterButton} ${styles.default}`}
              icon={<DeleteOutlined />}
              onClick={() => onDelete(gift)}
            >
              Xóa
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
